import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter } from "react-router-dom";

import { Provider } from "react-redux";

import store from "./store";
import "./assets/themechnage.css";
import "./assets/ReactCrop.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./assets/style.css";

// Sanitize corrupted lang_id in localStorage before anything reads it
const rawLangId = localStorage.getItem("lang_id");
if (rawLangId) {
  const clean = parseInt(rawLangId);
  if (isNaN(clean) || String(clean) !== rawLangId.trim()) {
    localStorage.setItem("lang_id", isNaN(clean) ? "1" : String(clean));
  }
}

// Suppress unhandled auth-related rejections from showing the CRA error overlay.
// The interceptors in api.js / api_helper.js already handle these gracefully.
window.addEventListener("unhandledrejection", (event) => {
  const status = event.reason?.response?.status;
  const errMsg = event.reason?.message || "";
  if (
    status === 401 ||
    status === 403 ||
    errMsg.includes("401") ||
    errMsg.includes("403")
  ) {
    event.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <App />
    <ToastContainer />
  </Provider>
);

serviceWorker.unregister();
